/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * UserAdditionalDetailsBase
 * auto generated base class for the model UserAdditionalDetailsModel.
 */
export const UserAdditionalDetailsModelBase = ModelBase.named('UserAdditionalDetails')
  .props({
    __typename: types.optional(types.literal('UserAdditionalDetails'), 'UserAdditionalDetails'),
    address: types.union(types.undefined, types.null, types.string),
    age: types.union(types.undefined, types.null, types.string),
    email: types.union(types.undefined, types.string),
    firstName: types.union(types.undefined, types.string),
    heardAboutPokerPower: types.union(types.undefined, types.null, types.string),
    lastName: types.union(types.undefined, types.string),
    phoneNumber: types.union(types.undefined, types.null, types.string),
    promoCode: types.union(types.undefined, types.null, types.string),
    segmentAnonymousId: types.union(types.undefined, types.null, types.string),
    stripeId: types.union(types.undefined, types.null, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserAdditionalDetailsModelSelector extends QueryBuilder {
  get address() {
    return this.__attr('address')
  }
  get age() {
    return this.__attr('age')
  }
  get email() {
    return this.__attr('email')
  }
  get firstName() {
    return this.__attr('firstName')
  }
  get heardAboutPokerPower() {
    return this.__attr('heardAboutPokerPower')
  }
  get lastName() {
    return this.__attr('lastName')
  }
  get phoneNumber() {
    return this.__attr('phoneNumber')
  }
  get promoCode() {
    return this.__attr('promoCode')
  }
  get segmentAnonymousId() {
    return this.__attr('segmentAnonymousId')
  }
  get stripeId() {
    return this.__attr('stripeId')
  }
}
export function selectFromUserAdditionalDetails() {
  return new UserAdditionalDetailsModelSelector()
}

export const userAdditionalDetailsModelPrimitives =
  selectFromUserAdditionalDetails().address.age.email.firstName.heardAboutPokerPower.lastName.phoneNumber.promoCode
    .segmentAnonymousId.stripeId
